var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createContext, useContext } from "react";
import { DEFAULT_APP_SIZE } from "./useAppSizeMedia";
/**
 * @internal
 */
export var AppSizeContext = createContext(__assign(__assign({}, DEFAULT_APP_SIZE), { __initialized: false }));
/**
 * Gets the current app size.
 *
 * @returns the current AppSize
 */
export function useAppSize() {
    var _a = useContext(AppSizeContext), __initialized = _a.__initialized, context = __rest(_a, ["__initialized"]);
    if (!__initialized) {
        throw new Error("Unable to get the current `AppSize` from `react-md` because the `AppSizeListener` " +
            "could not be found when using the `useAppSize` hook. To fix this error, either " +
            "initialize the `AppSizeListener` component from `@react-md/utils` or the " +
            "`Configuration` component from `@react-md/layout` near the root of your app.");
    }
    return context;
}
//# sourceMappingURL=useAppSize.js.map